var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentIcon20X20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7332_55787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13L13 12H6.00003L6 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 14H11.9962L11.9962 16H6.00003V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 0.557617L3.00002 -0.442383L2.00002 -0.442384L2.00002 0.557616L3.00002 0.557617ZM3 19L2 19L2 20H3V19ZM17 19V20H18L18 19L17 19ZM17.0002 4.99947H18.0002V4.61445L17.742 4.32884L17.0002 4.99947ZM12.9844 0.557634L13.7262 -0.113001L13.4284 -0.442365L12.9844 -0.442366L12.9844 0.557634ZM13.979 0.558008C13.979 0.00572342 13.5312 -0.441986 12.9789 -0.44198C12.4267 -0.441973 11.979 0.0057478 11.979 0.558033L13.979 0.558008ZM12.979 5.55762L11.979 5.55763L11.979 6.55762H12.979V5.55762ZM16.9844 6.55762C17.5367 6.55762 17.9844 6.1099 17.9844 5.55762C17.9844 5.00533 17.5367 4.55762 16.9844 4.55762V6.55762ZM2.00002 0.557616L2 19L4 19L4.00002 0.557618L2.00002 0.557616ZM17.742 4.32884L13.7262 -0.113001L12.2426 1.22827L16.2584 5.67011L17.742 4.32884ZM12.9844 -0.442366L3.00002 -0.442383L3.00002 1.55762L12.9844 1.55763L12.9844 -0.442366ZM3 20H17V18H3V20ZM18 19C18.0001 14.6932 18.0002 9.30628 18.0002 4.99947H16.0002C16.0002 9.30626 16.0001 14.6932 16 19L18 19ZM11.979 0.558033L11.979 5.55763L13.979 5.5576L13.979 0.558008L11.979 0.558033ZM12.979 6.55762H16.9844V4.55762H12.979V6.55762Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7332_55787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon20X20);
export default __webpack_public_path__ + "static/media/content_icon20x20.0b19bf5c.svg";
export { ForwardRef as ReactComponent };